import CommCodeModel from './CommCodeModel';
import MappingModel from './MappingModel';
import ProcessModel from './ProcessModel';
import QueueModel from './QueueModel';

export default {
	CommCodeModel,
	MappingModel,
	ProcessModel,
	QueueModel
};

export { CommCodeModel, MappingModel, ProcessModel, QueueModel };
